var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.148,
    height: 13.276,
    viewBox: "0 0 20.148 13.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "videoCallIcon",
    transform: "translate(0.625 0.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12961",
    "data-name": "Group 12961",
    transform: "translate(-1.11 -4.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-video",
    "data-name": "Icon feather-video",
    transform: "translate(1.11 4.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14377",
    "data-name": "Path 14377",
    d: "M30.013,10.5,24,14.8l6.013,4.3Z",
    transform: "translate(-11.115 -8.782)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14378",
    "data-name": "Path 14378",
    d: "M3.218,7.5h9.449a1.718,1.718,0,0,1,1.718,1.718v8.59a1.718,1.718,0,0,1-1.718,1.718H3.218A1.718,1.718,0,0,1,1.5,17.808V9.218A1.718,1.718,0,0,1,3.218,7.5Z",
    transform: "translate(-1.5 -7.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCallIcon);
export default __webpack_public_path__ + "static/media/videoCallIcon.43e283527b31f27b92587796c1dc19a0.svg";
export { ForwardRef as ReactComponent };